var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "whatsapp-chat-starter",
      class: { "fullscreen-mode": _vm.fullscreenMode },
    },
    [
      _c("h1", { staticClass: "gradient-title" }, [
        _vm._v(_vm._s(_vm.$t("message.wpStartSpeech"))),
      ]),
      _vm._v(" "),
      _vm.fullscreenMode
        ? _c("div", { staticClass: "icon-flow" }, [
            _c("div", { staticClass: "icon zoho" }, [_c("ZohoIcon")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "arrow" }),
            _vm._v(" "),
            _c("div", { staticClass: "icon supsis" }, [_c("SupsisIcon")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "arrow" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "icon whatsapp" },
              [_c("WhatsappBusinessIcon")],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("PhoneFormaterinput", {
        model: {
          value: _vm.phoneNumber,
          callback: function ($$v) {
            _vm.phoneNumber = $$v
          },
          expression: "phoneNumber",
        },
      }),
      _vm._v(" "),
      _c("div", [
        _c("label", { attrs: { for: "contactName" } }, [_vm._v("İsim")]),
        _vm._v(" "),
        _c("small", [_vm._v("Kişinin adını girin (opsiyonel)")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.name,
              expression: "name",
            },
          ],
          staticClass: "contact-input",
          attrs: { type: "text", placeholder: "Örn: Ahmet Yılmaz" },
          domProps: { value: _vm.name },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.name = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", { attrs: { for: "contactEmail" } }, [_vm._v("E-posta")]),
        _vm._v(" "),
        _c("small", [_vm._v("Kişinin e-posta adresini girin (opsiyonel)")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.email,
              expression: "email",
            },
          ],
          staticClass: "contact-input",
          attrs: { type: "email", placeholder: "Örn: ahmet@example.com" },
          domProps: { value: _vm.email },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.email = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm.whatsappChannels.length === 1
        ? _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.channelId,
                  expression: "channelId",
                },
              ],
              attrs: { type: "hidden" },
              domProps: { value: _vm.channelId },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.channelId = $event.target.value
                },
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.fullscreenMode
        ? _c(
            "div",
            [
              _c("label", { attrs: { for: "channelId" } }, [
                _vm._v(_vm._s(_vm.$t("message.channel"))),
              ]),
              _vm._v(" "),
              _c("small", [_vm._v(_vm._s(_vm.$t("message.channelDesc")))]),
              _vm._v(" "),
              _c("ChannelPicker", {
                attrs: {
                  "allowed-types": [
                    "whatsapp-qr",
                    "whatsapp-v2",
                    "whatsapp-business-api",
                    "whatsapp-unipile",
                    "whatsapp-business-api-supsis",
                  ],
                  autoSelectFirst: false,
                },
                model: {
                  value: _vm.channelId,
                  callback: function ($$v) {
                    _vm.channelId = $$v
                  },
                  expression: "channelId",
                },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "fullscreen-content" }, [
            _c("div", { staticClass: "channel-select-text" }, [
              _vm._v(_vm._s(_vm.$t("message.pleaseSelectStartChat"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "channel-boxes" },
              _vm._l(_vm.whatsappChannels, function (channel) {
                return _c(
                  "div",
                  {
                    key: channel._id,
                    staticClass: "channel-box",
                    class: {
                      selected: _vm.channelId === channel._id,
                      disabled: !_vm.isChannelAvailable(channel),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectChannel(channel)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "channel-icon", class: channel.type },
                      [
                        channel.type === "whatsapp-business-api"
                          ? _c("WhatsappBusinessIcon")
                          : channel.type === "whatsapp-v2"
                          ? _c("WhatsappV2")
                          : channel.type === "whatsapp-unipile"
                          ? _c("WhatsappV3")
                          : channel.type === "whatsapp-qr"
                          ? _c("WhatsappV1")
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "channel-name" }, [
                      _vm._v(_vm._s(channel.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "channel-number" }, [
                      _vm._v(_vm._s(channel.payload.phoneNumber)),
                    ]),
                    _vm._v(" "),
                    !_vm.isChannelAvailable(channel)
                      ? _c("div", { staticClass: "warning-text" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("message.notAuthorizedChannel")) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]),
      _vm._v(" "),
      _vm.isUnipileChannel
        ? _c("div", [
            _c("label", { attrs: { for: "defaultInitialMessage" } }, [
              _vm._v("Başlangıç Mesajı"),
            ]),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                "WhatsApp V3 kanalı için başlangıç mesajı önem taşır eğer boş bırakırsanız karşı tarafa bir adet boşluk içeren boş  mesaj iletilecektir. "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.defaultInitialMessage,
                  expression: "defaultInitialMessage",
                },
              ],
              staticClass: "initial-message-input",
              attrs: {
                type: "text",
                placeholder: "Merhaba, size nasıl yardımcı olabilirim?",
              },
              domProps: { value: _vm.defaultInitialMessage },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.defaultInitialMessage = $event.target.value
                },
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("footer", [
        _c(
          "div",
          { staticClass: "button-group" },
          [
            _c(
              "SupsisButton",
              { attrs: { danger: "" }, on: { click: _vm.cancel } },
              [_vm._v("Vazgeç")]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: {
                  primary: "",
                  disabled: !_vm.isFormValid || _vm.isSending,
                },
                on: { click: _vm.startChat },
              },
              [_vm._v("\n                Sohbet Başlat\n            ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isSending
        ? _c("div", { staticClass: "loading-overlay" }, [
            _c("div", { staticClass: "spinner" }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }